export enum PayInPayOut {
    PAYIN = 1,
    PAYOUT = 2
}